import React from 'react';
import DeviceSelection from '../../../DeviceSelection';
import SpeakerIcon from '../../../common/Icons/Speaker';
import { useTwilioUserMediaContext } from '../../../../customer-call-sdk';
import Messages from '../../../../config/messages.constants';

const defaultSpeaker: MediaDeviceInfo = {
    deviceId: 'default',
    kind: 'audiooutput',
    label: 'Default',
    groupId: '',
    toJSON: () => {},
};

/**
 * Camera selection list item
 */
const SpeakerSelection: React.FC = () => {
    const { speakers, speakerDeviceId, setSpeakerDeviceId } = useTwilioUserMediaContext();
    const selectedSpeaker =
        speakers.find((speaker) => speaker.deviceId === speakerDeviceId) || null;
    const speakersUnavailable = speakers.length === 0;
    /**
     * Handle select change
     *
     * @param {MediaDeviceInfo} value selected camera
     */
    const handleChange = (value: MediaDeviceInfo) => {
        setSpeakerDeviceId(value.deviceId);
    };

    return (
        <DeviceSelection
            icon={SpeakerIcon}
            primaryText={Messages.DEVICE_SETTING.SPEAKER.TITLE}
            value={speakersUnavailable ? defaultSpeaker : selectedSpeaker}
            options={speakersUnavailable ? [defaultSpeaker] : speakers}
            onChange={handleChange}
            data-testid="camera-device-setting"
            id="camera-device-setting"
            disabled={speakersUnavailable}
            ariaLabel="speaker options"
        />
    );
};

export default SpeakerSelection;
